import { render, staticRenderFns } from "./headLogo.vue?vue&type=template&id=15467488&scoped=true&"
import script from "./headLogo.vue?vue&type=script&lang=js&"
export * from "./headLogo.vue?vue&type=script&lang=js&"
import style0 from "./headLogo.vue?vue&type=style&index=0&id=15467488&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15467488",
  null
  
)

export default component.exports